import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid, CircularProgress } from '@mui/material';
import { Primary, Secondary } from 'ui-components/Buttons';
import { useTheme } from '@emotion/react';

// `maxWidth` is MUI's own Dialog prop ('xs' 444px, 'sm' 600px, ...). It defaults to
// 'sm', which is what MUI already used here, so every existing caller renders exactly as
// before - only a caller that asks for a narrower box gets one. Deliberately NOT an `sx`
// passthrough: several callers already pass sx that this component never forwarded, and
// wiring it up would activate all of that dormant styling at once across 21 files.
const DeleteConfirmationDialog = ({ open, handleClose, handleSubmission, heading, subheading, ActionText, CancelText, invertActions = false, removeConfirmation = false, removeCancellation = false, loading = false, maxWidth = 'sm' }) => {
    const theme = useTheme();
    // console.log(removeConfirmation,"removeConfirmation")
    return (
        <Dialog open={open} onClose={handleClose} maxWidth={maxWidth} aria-labelledby="delete-confirmation-dialog" sx={{
            "& > .MuiDialog-container > .MuiPaper-root": {
                borderRadius: "20px"
            },
        }}>
            <DialogTitle id="delete-confirmation-dialog" sx={{ textAlign: 'center', fontWeight: 700, fontSize: '1.5rem', color: theme.palette.customColors.g300 }}>
                {heading ? heading : "Confirm Deletion"}
            </DialogTitle>
            <DialogContent sx={{ padding: "10px 24px" }}>
                <Grid container justifyContent="center">
                    <Typography sx={{ fontSize: '1rem', color: theme.palette.customColors.g200, textAlign: 'center' }}>
                        {subheading ? subheading : 'Are you sure you want to delete this item? This action cannot be undone.'}
                    </Typography>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', padding: '1rem 1.5rem 1.5rem 1.5rem' }}>
                {!removeCancellation && <Secondary onClick={invertActions ? handleSubmission : handleClose} fullWidth
                    sx={{
                        padding: '0.75rem 1.25rem',
                        fontSize: '1rem',
                        width: removeConfirmation ? "50%" : "100%",
                        marginRight: removeConfirmation ? "0rem" : "1rem"
                    }}>
                    {invertActions ? (loading ? <CircularProgress size={"1.2rem"} /> : (ActionText ? ActionText : "Delete")) : (CancelText ? CancelText : "Cancel")}
                </Secondary>}
                {!removeConfirmation && <Primary onClick={invertActions ? handleClose : handleSubmission} fullWidth sx={{
                    padding: '0.75rem 1.25rem', fontSize: '1rem', backgroundColor: theme.palette.customColors.red,
                    width: removeCancellation ? "50%" : "100%",
                }}>
                    {invertActions ? (CancelText ? CancelText : "Cancel") : (loading ? <CircularProgress size={"1.2rem"} /> : (ActionText ? ActionText : "Delete"))}
                </Primary>}
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmationDialog;
